// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pdf {
  position: absolute;
  line-height: 1.2rem;
}
.pdf ::ng-deep p {
  font-size: 18px;
  font-weight: 400;
  line-height: 25px;
}
.pdf .pdf-main {
  display: flex;
  align-content: space-around;
  justify-content: space-between;
  margin: 2rem 2rem 1rem;
  height: calc(65vh - 3rem);
  overflow: hidden;
}
.pdf .pdf-product-image {
  height: 100%;
  max-height: 100%;
  width: 20vw;
  min-width: 20vw;
  margin-top: 1rem;
}
.pdf .pdf-product-image img {
  height: calc(100% - 2rem) !important;
}
.pdf .ba-percentage-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  padding: 0.5rem 2rem 0;
  justify-items: center;
}
.pdf .ba-percentage-wrapper fa-icon::ng-deep svg {
  color: #c9c9c9;
  width: 0.8rem;
  height: 0.8rem;
}
.pdf .pdf-product-info {
  margin: 0 0.8rem;
}
.pdf .pdf-product-info .pdf-title h1 {
  font-size: 2.2rem;
  line-height: 2.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
}
.pdf .pdf-product-info .pdf-title h2 {
  font-size: 1.4rem;
  line-height: 1.8rem;
}
.pdf .pdf-divider {
  border-left: 1px solid black;
  margin: 2rem 0.5rem 0;
}
.pdf .pdf-product-reviews {
  min-width: 25vw;
  width: 25vw;
  margin-right: 0.6rem;
  margin-top: 2rem;
}
.pdf .pdf-product-reviews h3 {
  margin-top: 0.5rem;
  font-size: 1.2rem;
  font-weight: 700;
}
.pdf .pdf-product-reviews .product-review-title {
  font-weight: 700;
  margin-bottom: 0;
}
.pdf .pdf-bottom {
  background-color: #000;
  color: white;
  display: flex;
  -webkit-print-color-adjust: exact;
  height: 35vh;
  font-size: 1.1rem;
  line-height: 1.2rem;
  overflow: hidden;
}
.pdf .pdf-bottom .pdf-bottom-container {
  margin: 1.5rem 3rem;
  display: flex;
}
.pdf .pdf-bottom .pdf-custom-attributes-left {
  margin-left: 0.5rem;
}
.pdf .pdf-bottom .pdf-custom-attributes-left p {
  margin-left: 0.5rem;
}
.pdf .pdf-bottom .pdf-custom-attributes-right {
  width: 22vw;
}
.pdf .pdf-bottom .pdf-custom-attributes-right p {
  margin: 0 0 1rem;
}
.pdf .pdf-bottom .product-foods {
  width: 14vw;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.pdf .pdf-bottom .product-foods .product-food {
  width: 50%;
  padding: 4px;
}
.pdf .pdf-bottom .bottom-divider {
  border-left: white 1px solid;
  margin: 0 1rem;
}
.pdf .pdf-bottom .attribute-label {
  font-weight: 700;
}

@media print {
  @page {
    size: auto;
    margin: 0;
  }
}
@media screen {
  :host {
    display: none;
  }
}
* { /* Chrome, Safari, Edge */
  print-color-adjust: exact !important; /*Firefox*/
}`, "",{"version":3,"sources":["webpack://./src/app/content/modules/page/components/product/components/print-pdf/print-pdf.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,mBAAA;AACF;AACE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AACJ;AAEE;EACE,aAAA;EACA,2BAAA;EACA,8BAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;AAAJ;AAGE;EACE,YAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AADJ;AAGI;EACE,oCAAA;AADN;AAKE;EACE,aAAA;EACA,kCAAA;EACA,sBAAA;EACA,qBAAA;AAHJ;AAKI;EACE,cAAA;EACA,aAAA;EACA,cAAA;AAHN;AAOE;EACE,gBAAA;AALJ;AAQM;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AANR;AASM;EACE,iBAAA;EACA,mBAAA;AAPR;AAYE;EACE,4BAAA;EACA,qBAAA;AAVJ;AAaE;EACE,eAAA;EACA,WAAA;EACA,oBAAA;EACA,gBAAA;AAXJ;AAaI;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;AAXN;AAcI;EACE,gBAAA;EACA,gBAAA;AAZN;AAgBE;EACE,sBAAA;EACA,YAAA;EACA,aAAA;EACA,iCAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AAdJ;AAgBI;EACE,mBAAA;EACA,aAAA;AAdN;AAiBI;EACE,mBAAA;AAfN;AAiBM;EACE,mBAAA;AAfR;AAmBI;EACE,WAAA;AAjBN;AAmBM;EACE,gBAAA;AAjBR;AAqBI;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAnBN;AAqBM;EACE,UAAA;EACA,YAAA;AAnBR;AAuBI;EACE,4BAAA;EACA,cAAA;AArBN;AAwBI;EACE,gBAAA;AAtBN;;AA4BA;EACE;IACE,UAAA;IACA,SAAA;EAzBF;AACF;AA4BA;EACE;IACE,aAAA;EA1BF;AACF;AA6BA,IACE,yBAAA;EACA,oCAAA,EAAA,UAAA;AA3BF","sourcesContent":[".pdf {\n  position: absolute;\n  line-height: 1.2rem;\n\n  ::ng-deep p {\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 25px;\n  }\n\n  .pdf-main {\n    display: flex;\n    align-content: space-around;\n    justify-content: space-between;\n    margin: 2rem 2rem 1rem;\n    height: calc(65vh - 3rem);\n    overflow: hidden;\n  }\n\n  .pdf-product-image {\n    height: 100%;\n    max-height: 100%;\n    width: 20vw;\n    min-width: 20vw;\n    margin-top: 1rem;\n\n    img {\n      height: calc(100% - 2rem) !important;\n    }\n  }\n\n  .ba-percentage-wrapper {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    padding: 0.5rem 2rem 0;\n    justify-items: center;\n\n    fa-icon::ng-deep svg {\n      color: #c9c9c9;\n      width: .8rem;\n      height: .8rem;\n    }\n  }\n\n  .pdf-product-info {\n    margin: 0 .8rem;\n\n    .pdf-title {\n      h1 {\n        font-size: 2.2rem;\n        line-height: 2.5rem;\n        font-weight: 700;\n        margin-bottom: 1rem;\n      }\n\n      h2 {\n        font-size: 1.4rem;\n        line-height: 1.8rem;\n      }\n    }\n  }\n\n  .pdf-divider {\n    border-left: 1px solid black;\n    margin: 2rem .5rem 0;\n  }\n\n  .pdf-product-reviews {\n    min-width: 25vw;\n    width: 25vw;\n    margin-right: .6rem;\n    margin-top: 2rem;\n\n    h3 {\n      margin-top: .5rem;\n      font-size: 1.2rem;\n      font-weight: 700;\n    }\n\n    .product-review-title {\n      font-weight: 700;\n      margin-bottom: 0;\n    }\n  }\n\n  .pdf-bottom {\n    background-color: #000;\n    color: white;\n    display: flex;\n    -webkit-print-color-adjust: exact;\n    height: 35vh;\n    font-size: 1.1rem;\n    line-height: 1.2rem;\n    overflow: hidden;\n\n    .pdf-bottom-container {\n      margin: 1.5rem 3rem;\n      display: flex;\n    }\n\n    .pdf-custom-attributes-left {\n      margin-left: .5rem;\n\n      p {\n        margin-left: .5rem;\n      }\n    }\n\n    .pdf-custom-attributes-right {\n      width: 22vw;\n\n      p {\n        margin: 0 0 1rem;\n      }\n    }\n\n    .product-foods {\n      width: 14vw;\n      display: flex;\n      flex-direction: row;\n      flex-wrap: wrap;\n\n      .product-food {\n        width: 50%;\n        padding: 4px;\n      }\n    }\n\n    .bottom-divider {\n      border-left: white 1px solid;\n      margin: 0 1rem;\n    }\n\n    .attribute-label {\n      font-weight: 700;\n    }\n  }\n\n}\n\n@media print {\n  @page {\n    size: auto;\n    margin: 0;\n  }\n}\n\n@media screen {\n  :host {\n    display: none;\n  }\n}\n\n* {\n  -webkit-print-color-adjust: exact !important; /* Chrome, Safari, Edge */\n  print-color-adjust: exact !important; /*Firefox*/\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
